/*
 * Copyright © 2025 Himitsu Lab Limited. All Rights Reserved.
 */

import { RecordingRequest } from '../models/recordingRequest.model';
import {allApis} from './allApis';

export const recordingRequestApi = allApis.injectEndpoints({
  overrideExisting: false,
  endpoints: builder => ({
    createRecordingRequest: builder.mutation<RecordingRequest, Partial<RecordingRequest>>({
      query: recordingRequest => ({
        url: `recording-requests`,
        method: 'POST',
        body: recordingRequest,
      }),
    }),
  }),
});
export const { useCreateRecordingRequestMutation } =
  recordingRequestApi;
